import { z } from 'zod'

/** Keep campaign tags across the root language redirect and landing validation. */
export const campaignSearchSchema = z.object({
  utm_source: z.string().max(128).optional().catch(undefined),
  utm_medium: z.string().max(128).optional().catch(undefined),
  utm_campaign: z.string().max(128).optional().catch(undefined),
  utm_content: z.string().max(128).optional().catch(undefined),
  utm_term: z.string().max(128).optional().catch(undefined),
})
